import { Download } from 'lucide-react'
import { saveAs } from 'file-saver'

const fileNameFromUrl = (fileUrl) => {
  if (!fileUrl) return 'file'
  const raw = fileUrl.includes('?')
    ? fileUrl.substring(fileUrl.lastIndexOf('/') + 1, fileUrl.indexOf('?'))
    : fileUrl.substring(fileUrl.lastIndexOf('/') + 1)
  try {
    return decodeURIComponent(raw) || 'file'
  } catch {
    return raw || 'file'
  }
}

const DownloadCard = ({ fileUrl }) => {
  const filename = fileNameFromUrl(fileUrl)

  const openInNewTab = () => {
    const newWindow = window.open(fileUrl, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  return (
    <div
      className="edvi-exam-file"
      role="button"
      tabIndex={0}
      onClick={openInNewTab}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          openInNewTab()
        }
      }}
      title={filename}
    >
      <p className="edvi-exam-file__name">{filename}</p>
      <button
        type="button"
        className="edvi-exam-file__btn"
        aria-label="Download file"
        onClick={(e) => {
          e.stopPropagation()
          saveAs(fileUrl)
        }}
      >
        <Download size={14} strokeWidth={2.25} />
      </button>
    </div>
  )
}

export default DownloadCard
